var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"rootRef",staticClass:"pm-plyr-wrapper",class:{ hidden: !_vm.playerReady }},[_vm._t("default",[_vm._v("SOMETHING WENT WRONG")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }